/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSuggestions} from '../api'

 export const useQueryGetSuggestions = createReactQueryHook('getSuggestions', getSuggestions)
